<div class="inline-flex-label">
    <!-- 类型 -->
    <span>{{logLabel}}</span>
    <n-help-icon class="title-tip" *ngIf="helpContent"
        [class.hidden]="helpIconHidden"
        [content]="helpContent">
    </n-help-icon>
    <!-- 导出 -->
    <button nButton theme="text" [border]="false"
        [id]="btnId"
        [label]="btnLabel"
        [disabled]="btnDisabled"
        [disabledTips]="btnDisabledTip"
        [loading]="btnLoading"
        (click)="btnClicked()">
    </button>
</div>
